import { ModelStorageSection } from './model-storage-section';
import type { MaasModelStorageBlockProps } from './types';

/** 模型存储能力块 */
export function MaasModelStorageBlock({ form, options }: MaasModelStorageBlockProps) {
  return (
    <ModelStorageSection
      form={form}
      skuOuterForm={options?.skuOuterForm}
      cluster={options?.cluster}
      namespace={options?.namespace}
      typeOptions={options?.typeOptions}
      initValues={options?.initValues}
      fromRepo={options?.fromRepo}
      isEdit={options?.isEdit}
      billModelId={options?.billModelId}
      deploymentTypeId={options?.deploymentTypeId}
      paymentTiming={options?.paymentTiming}
      skuType={options?.skuType}
      resourceEditMode={options?.resourceEditMode}
      lockActionsWhenFilled={options?.lockActionsWhenFilled}
      resourceCode={options?.resourceCode}
      onPriceChange={options?.onPriceChange}
      modelInstanceMultiSource={options?.modelInstanceMultiSource}
    />
  );
}
